"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUserAuthenticationForSSO = exports.setUserAuthentication = exports.setApiGatewayUrl = exports.mappingUrlProduction = exports.getUrlFromStorage = exports.getPublicApi = exports.getPlatformApiGatewayUrl = exports.getCurrentHost = exports.getApiGatewayUrl = void 0;
var getUrlFromStorage = function getUrlFromStorage() {
  var obj = JSON.parse(localStorage.getItem("apiGatewayUrl")) || {};
  return obj && obj[getCurrentHost()];
};
exports.getUrlFromStorage = getUrlFromStorage;
var getApiGatewayUrl = function getApiGatewayUrl() {
  var _JSON$parse;
  var url = getUrlFromStorage();
  var systemAdminUrl = (_JSON$parse = JSON.parse(localStorage.getItem(process.env.REACT_APP_DASHBOARD_SESSION_AUTH_KEY))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.apiGatewayUrl;
  if (systemAdminUrl) {
    return systemAdminUrl;
  } else {
    return url ? url : process.env.REACT_APP_DASHBOARD_API_URL;
  }
};
exports.getApiGatewayUrl = getApiGatewayUrl;
var getPlatformApiGatewayUrl = function getPlatformApiGatewayUrl() {
  var obj = JSON.parse(localStorage.getItem("apiGatewayUrl")) || {};
  return obj && obj[getCurrentHost()];
};
exports.getPlatformApiGatewayUrl = getPlatformApiGatewayUrl;
var getCurrentHost = function getCurrentHost() {
  var currentHost = window.location.hostname;
  if (window.location.hostname === "localhost") {
    currentHost = process.env.REACT_APP_DASHBOARD_HOST_URL;
  }
  return currentHost;
};
exports.getCurrentHost = getCurrentHost;
var setApiGatewayUrl = function setApiGatewayUrl(backendApi) {
  var obj = JSON.parse(localStorage.getItem("apiGatewayUrl")) || {};
  obj[getCurrentHost()] = backendApi;
  localStorage.setItem("apiGatewayUrl", JSON.stringify(obj));
};
exports.setApiGatewayUrl = setApiGatewayUrl;
var setUserAuthentication = function setUserAuthentication(response, oldUser) {
  var _response$data, _response$data$data, _response$data2, _response$data2$data, _response$data3, _response$data3$data, _response$data4, _response$data4$data, _response$data4$data$, _response$data5, _response$data5$data, _response$data6, _response$data6$data;
  var user = {
    token: "".concat(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$data = _response$data.data) === null || _response$data$data === void 0 ? void 0 : _response$data$data.type, " ").concat(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$data = _response$data2.data) === null || _response$data2$data === void 0 ? void 0 : _response$data2$data.accessToken),
    refreshToken: response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$data = _response$data3.data) === null || _response$data3$data === void 0 ? void 0 : _response$data3$data.refreshToken,
    roleId: response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : (_response$data4$data = _response$data4.data) === null || _response$data4$data === void 0 ? void 0 : (_response$data4$data$ = _response$data4$data.role) === null || _response$data4$data$ === void 0 ? void 0 : _response$data4$data$.id,
    downloadToken: response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : (_response$data5$data = _response$data5.data) === null || _response$data5$data === void 0 ? void 0 : _response$data5$data.downloadToken,
    expiryDate: new Date()
  };
  if (oldUser !== null && oldUser !== void 0 && oldUser.isReport || (oldUser === null || oldUser === void 0 ? void 0 : oldUser.isReport) === false) {
    user.isReport = oldUser.isReport;
  }
  if (oldUser !== null && oldUser !== void 0 && oldUser.recordId) {
    user.recordId = oldUser.recordId;
  }
  if (oldUser !== null && oldUser !== void 0 && oldUser.apiGatewayUrl || response !== null && response !== void 0 && (_response$data6 = response.data) !== null && _response$data6 !== void 0 && (_response$data6$data = _response$data6.data) !== null && _response$data6$data !== void 0 && _response$data6$data.apiGatewayUrl) {
    var _response$data7, _response$data7$data;
    if (oldUser !== null && oldUser !== void 0 && oldUser.apiGatewayUrl) {
      user["apiGatewayUrl"] = oldUser.apiGatewayUrl;
    } else if (response !== null && response !== void 0 && (_response$data7 = response.data) !== null && _response$data7 !== void 0 && (_response$data7$data = _response$data7.data) !== null && _response$data7$data !== void 0 && _response$data7$data.apiGatewayUrl) {
      user["apiGatewayUrl"] = response.data.data.apiGatewayUrl;
    }
  }
  return user;
};
exports.setUserAuthentication = setUserAuthentication;
var setUserAuthenticationForSSO = function setUserAuthenticationForSSO(response, oldUser) {
  var _response$data8, _response$data8$data, _response$data8$data$, _response$data9, _response$data9$data, _response$data9$data$, _response$data10, _response$data10$data, _response$data10$data2, _response$data11, _response$data11$data, _response$data11$data2, _response$data11$data3, _response$data12, _response$data12$data, _response$data12$data2, _response$data14, _response$data14$data, _response$data15, _response$data15$data;
  var user = {
    token: "".concat(response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : (_response$data8$data = _response$data8.data) === null || _response$data8$data === void 0 ? void 0 : (_response$data8$data$ = _response$data8$data.tokenDTO) === null || _response$data8$data$ === void 0 ? void 0 : _response$data8$data$.type, " ").concat(response === null || response === void 0 ? void 0 : (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : (_response$data9$data = _response$data9.data) === null || _response$data9$data === void 0 ? void 0 : (_response$data9$data$ = _response$data9$data.tokenDTO) === null || _response$data9$data$ === void 0 ? void 0 : _response$data9$data$.accessToken),
    refreshToken: response === null || response === void 0 ? void 0 : (_response$data10 = response.data) === null || _response$data10 === void 0 ? void 0 : (_response$data10$data = _response$data10.data) === null || _response$data10$data === void 0 ? void 0 : (_response$data10$data2 = _response$data10$data.tokenDTO) === null || _response$data10$data2 === void 0 ? void 0 : _response$data10$data2.refreshToken,
    roleId: response === null || response === void 0 ? void 0 : (_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : (_response$data11$data = _response$data11.data) === null || _response$data11$data === void 0 ? void 0 : (_response$data11$data2 = _response$data11$data.tokenDTO) === null || _response$data11$data2 === void 0 ? void 0 : (_response$data11$data3 = _response$data11$data2.role) === null || _response$data11$data3 === void 0 ? void 0 : _response$data11$data3.id,
    expiryDate: new Date()
  };
  if (oldUser !== null && oldUser !== void 0 && oldUser.isReport || (oldUser === null || oldUser === void 0 ? void 0 : oldUser.isReport) === false) {
    user.isReport = oldUser.isReport;
  }
  if (oldUser !== null && oldUser !== void 0 && oldUser.recordId) {
    user.recordId = oldUser.recordId;
  }
  if (oldUser !== null && oldUser !== void 0 && oldUser.apiGatewayUrl || response !== null && response !== void 0 && (_response$data12 = response.data) !== null && _response$data12 !== void 0 && (_response$data12$data = _response$data12.data) !== null && _response$data12$data !== void 0 && (_response$data12$data2 = _response$data12$data.tokenDTO) !== null && _response$data12$data2 !== void 0 && _response$data12$data2.apiGatewayUrl) {
    var _response$data13, _response$data13$data, _response$data13$data2;
    if (oldUser !== null && oldUser !== void 0 && oldUser.apiGatewayUrl) {
      user["apiGatewayUrl"] = oldUser.apiGatewayUrl;
    } else if (response !== null && response !== void 0 && (_response$data13 = response.data) !== null && _response$data13 !== void 0 && (_response$data13$data = _response$data13.data) !== null && _response$data13$data !== void 0 && (_response$data13$data2 = _response$data13$data.tokenDTO) !== null && _response$data13$data2 !== void 0 && _response$data13$data2.apiGatewayUrl) {
      user["apiGatewayUrl"] = response.data.data.tokenDTO.apiGatewayUrl;
    }
  }
  if (response !== null && response !== void 0 && (_response$data14 = response.data) !== null && _response$data14 !== void 0 && (_response$data14$data = _response$data14.data) !== null && _response$data14$data !== void 0 && _response$data14$data.deviceId && response !== null && response !== void 0 && (_response$data15 = response.data) !== null && _response$data15 !== void 0 && (_response$data15$data = _response$data15.data) !== null && _response$data15$data !== void 0 && _response$data15$data.email) {
    var _response$data16, _response$data16$data, _response$data17, _response$data17$data;
    setDeviceId(response === null || response === void 0 ? void 0 : (_response$data16 = response.data) === null || _response$data16 === void 0 ? void 0 : (_response$data16$data = _response$data16.data) === null || _response$data16$data === void 0 ? void 0 : _response$data16$data.deviceId, response === null || response === void 0 ? void 0 : (_response$data17 = response.data) === null || _response$data17 === void 0 ? void 0 : (_response$data17$data = _response$data17.data) === null || _response$data17$data === void 0 ? void 0 : _response$data17$data.email);
  }
  return user;
};
exports.setUserAuthenticationForSSO = setUserAuthenticationForSSO;
var getPublicApi = function getPublicApi() {
  var url = getUrlFromStorage();
  return url ? url : process.env.REACT_APP_DASHBOARD_API_URL;
};
exports.getPublicApi = getPublicApi;
var setDeviceId = function setDeviceId(deviceId, email) {
  var _deviceArray;
  var deviceArray = [];
  try {
    deviceArray = JSON.parse(localStorage.getItem(process.env.REACT_APP_DEVICE_AUTH_KEY)) || [];
  } catch (ex) {}
  var obj = (_deviceArray = deviceArray) === null || _deviceArray === void 0 ? void 0 : _deviceArray.find(function (f) {
    var _f$email;
    return (f === null || f === void 0 ? void 0 : (_f$email = f.email) === null || _f$email === void 0 ? void 0 : _f$email.toLocaleLowerCase()) === (email === null || email === void 0 ? void 0 : email.toLocaleLowerCase());
  });
  if (obj) {
    obj.token = deviceId;
  } else {
    var _deviceArray2;
    (_deviceArray2 = deviceArray) === null || _deviceArray2 === void 0 ? void 0 : _deviceArray2.push({
      token: deviceId,
      email: email === null || email === void 0 ? void 0 : email.toLocaleLowerCase()
    });
  }
  localStorage.setItem(process.env.REACT_APP_DEVICE_AUTH_KEY, JSON.stringify(deviceArray));
};
var mappingUrlProduction = [{
  key: "mysite.lehigh.edu",
  value: "lehigh"
}, {
  key: "mysite.chop.edu",
  value: "chop"
}, {
  key: "portal.mainehealth.org",
  value: "mainehealth"
}, {
  key: "impact.tulane.edu",
  value: "tulane"
}, {
  key: "impact.vcu.edu",
  value: "vcu"
}, {
  key: "mysite.ucsf.edu",
  value: "ucsf"
}, {
  key: "impact.virginia.edu",
  value: "virginia"
}, {
  key: "myimpact.susqu.edu",
  value: "susqu"
}, {
  key: "connect.childrenshospital.org",
  value: "childrenshospital"
}, {
  key: "myphilanthropy.tcu.edu",
  value: "tcu"
}, {
  key: "myimpact.ncsu.edu",
  value: "ncsu"
}, {
  key: "mysite.bucknell.edu",
  value: "bucknell"
}, {
  key: "mysite.peddie.org",
  value: "peddie"
}, {
  key: "mysite.iuhealthfoundation.org",
  value: "iuhealthfoundation"
}, {
  key: "mysite.dickinson.edu",
  value: "dickinson"
}, {
  key: "myimpact.muhlenberg.edu",
  value: "muhlenberg"
}, {
  key: "philanthropy.ucdenver.edu",
  value: "ucdenver"
}, {
  key: "intermountain.ovrture.com",
  value: "intermountain"
}, {
  key: "mysite.mdanderson.org",
  value: "mdanderson"
}, {
  key: "mysite.admin.bcm.edu",
  value: "baylor"
}, {
  key: "mysite.stanford.edu",
  value: "stanford"
}, {
  key: "myimpact.ucdavis.edu",
  value: "ucdavis"
}, {
  key: "ovrture.commonspirit.org",
  value: "commonspirit"
}, {
  key: "martsandlundy.ovrture.com",
  value: "martsandlundy"
}, {
  key: "myimpact.depaul.edu",
  value: "depaul"
}, {
  key: "myimpact.hbs.edu",
  value: "hbs"
}, {
  key: "myimpact.barnard.edu",
  value: "barnard"
}, {
  key: "myimpact.iuf.iu.edu",
  value: "iuf"
}, {
  key: "philanthropy.udel.edu",
  value: "udel"
}, {
  key: "myimpact.auburn.edu",
  value: "auburn"
}, {
  key: "education.ovrture.com",
  value: "ou"
}, {
  key: "healthcare.ovrture.com",
  value: "oh"
}, {
  key: "myimpact.oglebayfoundation.org",
  value: "oglebay"
}, {
  key: "myimpact.amherst.edu",
  value: "amherst"
}, {
  key: "myimpact.wvuf.org",
  value: "wvuf"
}, {
  key: "impact.stthomas.edu",
  value: "stthomas"
}, {
  key: "myimpact.sju.edu",
  value: "sju"
}, {
  key: "mysite.alz.org",
  value: "alz"
}, {
  key: "mysite.earthjustice.org",
  value: "earthjustice"
}, {
  key: "myimpact.childrensnational.org",
  value: "childrensnational"
}, {
  key: "myimpact.bc.edu",
  value: "bc"
}, {
  key: "mysite.niu.edu",
  value: "niu"
}, {
  key: "myimpact.usf.edu",
  value: "usf"
}, {
  key: "myimpact.ubc.ca",
  value: "ubc"
}, {
  key: "myimpact.usna.com",
  value: "usna"
}, {
  key: "myimpact.giving.massgeneral.org",
  value: "mgh"
}, {
  key: "myimpact.midpac.edu",
  value: "midpac"
}, {
  key: "myimpact.rice.edu",
  value: "rice"
}, {
  key: "impact.bu.edu",
  value: "boston"
}, {
  key: "myimpact.memphis.edu",
  value: "umem"
}, {
  key: "myimpact.branson.org",
  value: "branson"
}, {
  key: "impact.campbellhall.org",
  value: "campbell"
}, {
  key: "four.ovrture.com",
  value: "oup"
}, {
  key: "five.ovrture.com",
  value: "ohp"
}, {
  key: "impact.cincinnatichildrens.org",
  value: "cch"
}, {
  key: "myimpact.natgeo.org",
  value: "natgeo"
}, {
  key: "yourimpact.colonialwilliamsburg.org",
  value: "cwf"
}, {
  key: "mystewardship.lawrenceville.org",
  value: "lrs"
}, {
  key: "myimpact.osu.edu",
  value: "osu"
}, {
  key: "nrdc.react.production.ovrture.com",
  value: "nrdc"
}, {
  key: "myimpact.law.virginia.edu",
  value: "uval"
}, {
  key: "myimpact.miami.edu",
  value: "uofmiami"
}];
exports.mappingUrlProduction = mappingUrlProduction;